const s = {
  name: "UserAdmin",
  dimensions: { width: 36, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 36 40" style="enable-background:new 0 0 36 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill-rule:evenodd;clip-rule:evenodd;fill: currentColor;}
	.st1{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M10,8c0-4.4,3.6-8,8-8s8,3.6,8,8c0,4.4-3.6,8-8,8S10,12.4,10,8z M18,2c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6
			S21.3,2,18,2z"/>
		<path class="st1" d="M0,29c0-6.1,4.9-11,11-11h14c6.1,0,11,4.9,11,11v11h-2V29c0-5-4-9-9-9H11c-5,0-9,4-9,9v11H0V29z"/>
		<path class="st0" d="M24,26c-2.2,0-4,1.8-4,4c0,1.9,1.3,3.4,3,3.9V37h2v-3.1c1.7-0.4,3-2,3-3.9C28,27.8,26.2,26,24,26z M22,30
			c0-1.1,0.9-2,2-2s2,0.9,2,2c0,1.1-0.9,2-2,2S22,31.1,22,30z"/>
		<path class="st1" d="M6,40V30h2v10H6z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as UserAdmin
};
